// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const renderRoundedIcon = (_icon, _iconBgVersion) => null;
//# sourceMappingURL=renderRoundedIcon.js.map